var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"px-0 ml-2",attrs:{"icon":""},on:{"click":_vm.copyToClipboard}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" mdi-content-copy ")])],1)]}}])},[_c('span',[_vm._v("Kopieren")])])
}
var staticRenderFns = []

export { render, staticRenderFns }